const request = require('request');

exports.migratortronApi = request.defaults({
  baseUrl: 'http://localhost:3001/v1/',
  json: true,
});
